import * as React from 'react';
import { TrustedShopsWidgetComponent } from '@grandvisionhq/analytics';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import '@swc/helpers';
import '@grandvisionhq/state';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../utils/http-client.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';

const CmsWidgetTrustedShop = ({ meta: { scriptID  }  })=>{
    if (!scriptID || scriptID.trim() === '') {
        return null;
    }
    return /*#__PURE__*/ React.createElement(TrustedShopsWidgetComponent, {
        id: scriptID
    });
};
var WidgetTrustedShop = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withAnchor)(CmsWidgetTrustedShop);

export { CmsWidgetTrustedShop, WidgetTrustedShop as default };
//# sourceMappingURL=WidgetTrustedShop.js.map
